import { useCallback } from "react"
import { useError } from "../../context/useErrorContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { EResellerCommissionEntryStatus } from "../../Enum/EResellerCommissionEntryStatus"
import { useTranslation } from "react-i18next"

export interface ResellerCommissionEntry {
  id: number
  companyName: string
  grossPaymentAmount: number
  commissionPercentageApplied: number
  commissionAmount: number
  status: EResellerCommissionEntryStatus
  accruedAtUtc: string
  paidOutAtUtc: string | null
}

export const useGetResellerCommissions = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetResellerCommissions = useCallback(async (onSuccess: (entries: ResellerCommissionEntry[]) => void) => {
    try {
      const response = await GetRequest<ResellerCommissionEntry[]>(API_ROUTES.RESELLER.COMMISSIONS, ERequestType.Reseller)

      if (response.success && response.data) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }, [setError, t])

  return { handleGetResellerCommissions }
}
